<template>
 <v-app>
   <b-form v-show="spin == 1" @submit.prevent="addProduct" @reset="onReset" enctype="multipart/form-data">
 

 <b-form-group id="input-group-1" label="Ficha tecnica" label-for="input-1">
 
             <input   required class="e-input" name='input' type="text"  v-model="enlace.tecnica"/>
     </b-form-group>
     <b-form-group id="input-group-2" label="Hoja de seguridad" label-for="input-2">
           <input  id="input-1" required class="e-input" name='input' type="text" v-model="enlace.seguridad"/>
     </b-form-group>


      <b-button type="submit" variant="primary" COLOR="WHITE">GUARDAR PRODUCTO</b-button>
      <b-button type="reset" style="margin-left:15px;" variant="danger">REINICIAR</b-button>
    </b-form>
  </v-app>
  
</template>
<script>
import axios from 'axios'
export default {
  name:'Newtask',
 
  components: {

  },

  data () {
    return { 
          spin:1,
          categorias:[],
    divisiones:[],
    subcategorias:[],
    dataCategoria:{value:'categoria'},
    dataSubcategoria:{value:'subcategoria'},
    dataDivision:{value:'division'},
    imagenMiniatura: '',
      
     enlace:{
     
seguridad:'',
tecnica:'',
     },
    producto:{    
    
          nombre: '',
          division: '',
          categoria: '',
          subcategoria:'',
          descripcion:'',
          notasadicionales:'',
          codigo:'',
          notas:'',
          image:null
          },
 
      id: 'angel',   
    
    
  
    }
  },
  
 
  methods: {

addProduct(){
        this.spin = 2;
        let formData = new FormData();
       
        formData.append('seguridad',this.enlace.seguridad),
        formData.append('tecnica',this.enlace.tecnica),
        formData.append('idproducto',this.id),
      

        //axios.post('http://127.0.0.1:5050/productos/new', formData)
        axios.post('https://vicolors.com.mx/phpapi/productos/tasks', formData)
        .then(response => {
            console.log(response.data);
      
        })
},

      onReset(evt) {
        evt.preventDefault()
        // Reset our form values
        this.producto.nombre = '',
        this.producto.codigo = '',
        this.producto.descripcion = '',
        this.producto.division = '',
        this.producto.categoria = '',
        this.producto.subcategoria = '',
        this.producto.notas = '',
        this.producto.image = null,
        this.imagenMiniatura= ''
        this.imagen
        // Trick to reset/clear native browser form validation state
        this.show = false
        this.$nextTick(() => {
          this.show = true
        })
      },
  
     
  },
 computed: {
  
     
   
 },
 created() {
   
 },
 
}
</script>